
import { eventBus } from '@/utils/eventBus';

const DEFAULT_VISIBLE = '1';
const DEFAULT_OFFSET = { x: 20, y: 600 };

export default {
  data() {
    return {
      showBubble: true, // 初始占位
      bubbleOffset: { ...DEFAULT_OFFSET }
    };
  },
  beforeCreate() {

  },
  mounted() {
    // -------- bubble-visible --------
    let storedVisible = localStorage.getItem('bubble-visible');
    if (storedVisible === null) {
      storedVisible = DEFAULT_VISIBLE;
      localStorage.setItem('bubble-visible', DEFAULT_VISIBLE);
    }
    this.showBubble = storedVisible === '1';

    // -------- bubble-offset --------
    let storedOffset = localStorage.getItem('bubble-offset');
    if (storedOffset === null) {
      localStorage.setItem('bubble-offset', JSON.stringify(DEFAULT_OFFSET));
      this.bubbleOffset = { ...DEFAULT_OFFSET };
    } else {
      this.bubbleOffset = JSON.parse(storedOffset);
    }

    eventBus.on('bubble-visible-change', this.setBubbleVisible);
  },

  beforeUnmount() {
    eventBus.off('bubble-visible-change', this.setBubbleVisible);
  },

  methods: {
    setBubbleVisible(val) {
      this.showBubble = val;
      localStorage.setItem('bubble-visible', val ? '1' : '0');
    },

    onOffsetChange(offset) {
      const intOffset = { x: Math.round(offset.x), y: Math.round(offset.y) };
      this.bubbleOffset = intOffset;
      localStorage.setItem('bubble-offset', JSON.stringify(intOffset));
    },

    zhiNengKeFu() {
      window.open(
        'https://walle-h5.iyunbao.com/m/?accessId=1752550858417&tenantID=1',
        '_blank'
      );
    }
  }
};
